import { Menu, IconButton, ListItem, MenuItem } from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { useState } from 'react'

import ChannelAPIKeyModal from '../../components/UserAPIKeysModal'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { UserBrief } from '../../types/users'
import useStyles from './styles/UsersTable.styles'

interface UserRowMenuProps {
  data: UserBrief
}

export const UserRowMenu: React.FC<UserRowMenuProps> = ({ data }) => {
  const classes = useStyles()
  const [channelAPIKeyModalIsIpen, setchannelAPIKeyModalIsIpen] =
    useState(false)

  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOpenChannelAPIKeyModal = () => {
    setchannelAPIKeyModalIsIpen(true)
  }

  return (
    <div className={classes.rowMenu}>
      <IconButton onClick={handleClick}>
        <MoreIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <ListItem
          button
          component={LocalizedLink}
          to={`/access-management/user-management/user/${data.ID}`}>
          {getTranslate('Edit User')}
        </ListItem>
        {data.role?.includes('CHANNEL') && (
          <MenuItem
            className={classes.rowMenuItemAPIKey}
            onClick={handleOpenChannelAPIKeyModal}>
            {getTranslate('API Keys')}
          </MenuItem>
        )}
      </Menu>
      <ChannelAPIKeyModal
        onClose={() => setchannelAPIKeyModalIsIpen(false)}
        isOpen={channelAPIKeyModalIsIpen}
        channelID={data.entityID}
      />
    </div>
  )
}
